export const styles = {
  button: {
    marginLeft: 4,
    marginRight: 32
  },
  root: { display: 'flex', flexDirection: 'column' }
};
